import constants from '../common/constants'
import common from '../common/common'

let currentSession = null;
if (common.permanentStorage('currentSession')) {
  currentSession = JSON.parse(common.permanentStorage('currentSession'))
}

export default {
  /**
   * 获得当前session，不为空时标识已经登陆成功
   */
  getCurrentSession: function () {
    return currentSession || {}
  },
  /**
   * 设置当前session
   */
  setCurrentSession: function (data) {
    currentSession = data || {};
    common.permanentStorage('currentSession', currentSession)
  },
  /**
   * 单个设置当前session
   */
  setCurrentSessionByKey: function (key, value) {
    currentSession[key] = value;
    common.permanentStorage('currentSession', currentSession)
  },
  /**
   * 是否登录过
   */
  hasLogin: function () {
    return !!parseInt(common.permanentStorage(constants.hasLogin))
  },
  /**
   * 登出操作
   */
  logout: function () {
    currentSession = null;
    for (let k in localStorage) {
      localStorage.removeItem(k)
    }
    localStorage.removeItem('currentSession');
    localStorage.removeItem(constants.hasLogin)
  }
}



// WEBPACK FOOTER //
// ./common/session.js